export default __webpack_public_path__ + "static/media/template_business-man__0010_17---AaronZhang.f4d32520.png";